import Person from '../src/Person/index.tsx';
export default Person;
